<h1 mat-dialog-title i18n *ngIf="!dialogData.user.validated">Verify Email Address <small class="align-top">- {{dialogData.user.email}}</small></h1>
<h1 mat-dialog-title i18n *ngIf="dialogData.user.validated">Email Address Verified <small class="align-top">- {{dialogData.user.email}}</small></h1>

<form (ngSubmit)="onFormSubmit()">
	<div mat-dialog-actions class="row mb-0">
		<div class="col-6 text-center">
			<button
				class="w-100"
				mat-flat-button
				mat-dialog-close
				i18n
			>Cancel</button>
		</div>
		<div class="col-6 text-center">
			<button
				*ngIf="!dialogData.user.validated"
				class="w-100"
				type="submit"
				mat-flat-button
				color="primary"
				i18n
				cdkFocusInitial
			>Ok</button>
			<button
				*ngIf="dialogData.user.validated"
				class="w-100"
				type="button"
				mat-flat-button
				color="primary"
				i18n
				mat-dialog-close
				cdkFocusInitial
			>Ok</button>
		</div>
	</div>
</form>
